import { get, post, postJson, serialize } from '../httpClient';

// Each by-id endpoint takes a limited number of ids per request (MAX_IDS on the server). Split larger
// sets and merge the answers into one response of the same shape.
const PUBLIC_BATCH_SIZE = 25;
const SUBSCRIBER_BATCH_SIZE = 100;
const inBatches = async (ids, batchSize, fetchBatch) => {
  const unique = [...new Set((ids || []).filter(Boolean))];
  const batches = [];
  for (let i = 0; i < unique.length; i += batchSize) {
    batches.push(unique.slice(i, i + batchSize));
  }
  if (batches.length === 0) return { data: { data: { data: [], included: [] } } };
  const responses = await Promise.all(batches.map(fetchBatch));
  return {
    data: {
      data: {
        data: responses.flatMap(r => r?.data?.data?.data || []),
        included: responses.flatMap(r => r?.data?.data?.included || []),
      },
    },
  };
};

export const usersAPI = {
  show: params => get('/api/users/show', params),
  query: params => get('/api/users/query', params),
  // Public profiles for a known set of users.
  byIds: ids =>
    inBatches(ids, PUBLIC_BATCH_SIZE, batch => get('/api/users/by-ids', { ids: batch.join(',') })),
  // Subscribers of the caller's (or their organization's) Live Rooms, with email.
  subscriberProfiles: (ids, orgId) =>
    inBatches(ids, SUBSCRIBER_BATCH_SIZE, batch =>
      get('/api/users/subscriber-profiles', { ids: batch.join(','), ...(orgId ? { orgId } : {}) })
    ),
  communityTeam: () => get('/api/community/team'),
  search: params => get('/api/users/search', params),
  payoutsEnabled: params => get('/api/users/payouts-enabled', params),
  updateProfile: body => post('/api/users/update-profile', serialize(body)),
  // Follow or unfollow; the list stays private, the followed person gets a count.
  follow: (userId, follow) => postJson('/api/users/follow', { userId, follow }),
  processPendingInvites: body => postJson('/api/users/process-pending-invites', body),
};
